export default __webpack_public_path__ + "static/media/ellipse_slide_student_three.d58e2307.svg";